import React from 'react';

const SuccessMessage: React.FC = () => (
    <div className="cf-success-banner">
        <p className="cf-success-message">תודה רבה, קיבלנו את פנייתך ונענה בהקדם.</p>
    </div>
);

export default SuccessMessage;
